const maskFilter = function (input) {
    return input ? (input + '').replace(/./g, '●') : '';
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = maskFilter;
}
